@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" style="opacity: 0; transition: opacity 0.2s" />
	</div>
}

@if (loadingSubject | async) {
	<div class="overlay" style="z-index: 999999999; background-color: rgba(255, 255, 255, 0.8); position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; flex-direction: row; justify-content: center; align-items: center">
		<img src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'docs.sidebar.mappings' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field" style="margin-left: 1rem">
			<mat-form-field>
				<input matInput [placeholder]="'shared.search.placeholder' | translate" [(ngModel)]="mappingFilter" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<app-generictable
	#tableRef
	[hidden]="(count$ | async) <= 0"
	[tableData]="mappingData | async"
	[tableColumns]="registerTableColumns"
	[pageSizes]="pageSizes"
	[initialPageSize]="initialPageSize"
	[showFirstLastButtons]="false"
	[filterWord]="mappingFilter"
	[rowActions]="regRowActions"
	[hasSelectColumn]="true"
	(menuEmitter)="handleRowMenuAction($event)"
	(paginatorEmitter)="handleReloadData($event)"
	[totalRowCount]="count$ | async"></app-generictable>
